<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs color="transparent" slider-color="primary" v-model="tab">
          <v-tab v-for="(resource, index) of resources" :key="`tab${index}`">
            {{ resource.namePlural }}
          </v-tab>
        </v-tabs>

        <data-table v-for="(dataCard, key, index) of resources" :key="`dataCard${index}`" v-if="tab === index" :resource="resources[key]" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DataTable from '@/components/DataTable';
import { pickBy } from 'lodash';

export default {
  data() {
    return {
      tab: null
    };
  },

  computed: {
    resources() {
      return pickBy(this.$store.state.resources, item => {
        return item.systemSetup;
      });
    },
  },

  components: {
    DataTable
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/SystemSetup.vue